module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6a3c548c7991639567e6ff5a26ae10c.png";